import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'translateAnswers'
})
export class TranslateAnswersPipe implements PipeTransform {
    transform(answer: string | boolean): string {

        if (typeof answer === 'boolean') {
            return answer === true ? 'Sim' : 'Não';
        }
        if (answer && answer !== '') {
            switch (answer) {
                case 'true':
                    return 'Sim';
                case 'false':
                    return 'Não';
                case 'patient':
                    return 'Próprio Paciente';
                case 'companion':
                    return 'Acompanhante';
                case 'yes':
                    return 'Sim';
                case 'no':
                    return 'Não';
                case 'minorThenTwenty':
                    return '< 20 cigarros/dia';
                case 'twentyOneToForty':
                    return 'De 21 e 40 cigarros/dia';
                case 'greaterThenForty':
                    return '> 40 cigarros/dia';
                case 'leftRight':
                    return 'Esquerda/Direita';
                case 'left':
                    return 'Esquerda';
                case 'right':
                    return 'Direita';
                case 'absence_risk':
                    return 'Ausência de Risco';
                case 'iv_access':
                    return 'Acesso venoso inadequado';
                case 'namesake':
                    return 'Homônimo';
                case 'fall_risk':
                    return 'Risco de queda';
                case 'allergy':
                    return 'Alergia';
                case 'emotional_vulnerable':
                    return 'Emocional vulnerável';
                case 'infection':
                    return 'Infecção';
                case 'nutritional_risk':
                    return 'Risco nutricional';
                case 'verbal':
                    return 'Verbal';
                case 'notVerbal':
                    return 'Não verbal';
                case 'orientationPeriods':
                    return 'Períodos de orientação no tempo e espaço';
                case 'deorientationPeriods':
                    return 'Períodos de desorientação no tempo e espaço';
                case 'unconsciousnessPeriods':
                    return 'Períodos de inconsciência';
                case 'unconscious':
                    return 'Inconsciente';
                case 'ambulant':
                    return 'Ambulante';
                case 'needsAssistance':
                    return 'Necessita auxílio para deambular';
                case 'wheelchair':
                    return 'Locomoção através de cadeira de rodas';
                case 'bedridden':
                    return 'Restrito ao leito';
                case 'movesAllSegments':
                    return 'Movimenta todos os seguimentos corporais';
                case 'movementLimitations':
                    return 'Limitações de movimentos';
                case 'difficultyMovingSegments':
                    return 'Dificuldade para movimentar segmentos corporais. Mudança de decúbito e movimentação passiva auxiliada pela Enfermagem';
                case 'unableToMove':
                    return 'Incapaz de movimentar qualquer segmento corporal. Mudança de decúbito e movimentação passiva, programada e realizada pela Enfermagem';
                case 'selfSufficient':
                    return 'Autosuficiente';
                case 'nursingShowerBath':
                    return 'Banho de chuveiro e higiene oral realizada pela Enfermagem';
                case 'assistedShowerBath':
                    return 'Auxílio no banho de chuveiro e/ou higiene oral';
                case 'nursingBedBath':
                    return 'Banho de leito e higiene oral realizada pela Enfermagem';
                case 'corado':
                    return 'Corado';
                case 'hipocorado':
                    return 'Hipocorado';
                case 'hidratado':
                    return 'Hidratado';
                case 'hipohidratado':
                case 'Hipohidratado': // Para evitar problema com case sensitive
                    return 'Hipohidratado';
                case 'dermatitis':
                    return 'Dermatite';
                case 'petechiae':
                    return 'Petéquias';
                case 'mucositis':
                    return 'Mucosite';
                case 'ecchymosis':
                    return 'Equimose';
                case 'hematoma':
                    return 'Hematoma';
                case 'alopecia':
                    return 'Alopécia';
                case 'cyanosis':
                    return 'Cianose';
                case 'icteric':
                    return 'Ictérico';
                case 'hyperemia':
                    return 'Hiperemia';
                case 'radiodermatitis':
                    return 'Radiodermite';
                case 'descamacao':
                    return 'Descamação';
                case 'escoriacao':
                    return 'Escoriação';
                case 'prurido':
                    return 'Prurido';
                case 'seca':
                    return 'Seca';
                case 'outros':
                    return 'Outros';
                case 'noO2':
                    return 'Não depende de O2';
                case 'continuousO2':
                    return 'Uso contínuo de máscara ou catéter de O2';
                case 'intermittentO2':
                    return 'Uso intermitente de máscara ou catéter de O2';
                case 'mechanicalVentilation':
                    return 'Ventilação mecânica';
                case 'notPerformed':
                    return 'Não realizada';
                case 'SRA':
                    return 'SRA';
                case 'normal':
                    return 'Normal';
                case 'other':
                    return 'Outras';
                case 'symmetric':
                    return 'Simétrica';
                case 'asymmetric':
                    return 'Assimétrica';
                case 'routine_control_(every 8 hours)':
                    return 'Controle de rotina (a cada 8 horas)';
                case 'control_at_4_hour_intervals':
                    return 'Controle em intervalos de 4 horas';
                case 'control_at_6_hour_intervals':
                    return 'Controle em intervalos de 6 horas';
                case 'control_at_intervals_less_than_or_equal_to_2 hours':
                    return 'Controle em intervalos menores ou iguais a 2 horas';
                case 'rhythmic':
                    return 'Rítmicos';
                case 'arrhythmic':
                    return 'Arrítmicos';
                case 'full':
                    return 'Cheio';
                case 'filiform':
                    return 'Filiforme';
                case 'regular':
                    return 'Regular';
                case 'irregular':
                    return 'Irregular';
                case 'central':
                    return 'Central';
                case 'peripheral':
                    return 'Periférico';
                case 'oralWithAssistance':
                    return 'Por boca com auxílio';
                case 'gastricTube':
                    return 'Através de sonda gástrica';
                case 'centralCatheter':
                    return 'Através de catéter central';
                case 'nausea':
                    return 'Náuseas';
                case 'vomiting':
                    return 'Vômitos';
                case 'flaccid':
                    return 'Flácido';
                case 'rigid':
                    return 'Rígido';
                case 'painless':
                    return 'Indolor';
                case 'distended':
                    return 'Distendido';
                case 'palpableMass':
                    return 'Massa palpável';
                case 'painful':
                    return 'Doloroso';
                case 'absent':
                    return 'Ausente';
                case 'diminished':
                    return 'Diminuído';
                case 'increased':
                    return 'Aumentado';
                case 'bedpanOrBedEliminations':
                    return 'Uso de comadre ou eliminações no leito';
                case 'colostomy':
                    return 'Colostomia';
                case 'cystostomy':
                    return 'Cistostomia';
                case 'toiletWithAssistance':
                    return 'Uso de vaso sanitário com auxílio';
                case 'urinaryCatheter':
                    return 'Sonda vesical';
                case 'ileostomy':
                    return 'Ileostomia';
                case 'jejunostomy':
                    return 'Jejunostomia';
                case 'continuousEVOrNasogastricTube':
                    return 'EV contínuo ou através de sonda nasogástrica';
                case 'intermittentEV':
                    return 'EV intermitente';
                case 'imEvScVoItId':
                    return 'IM ou EV ou SC ou VO ou IT ou ID';
                case 'vasoactiveDrugsForBP':
                    return 'Uso de drogas vasoativas para manutenção de PA';
                case 'alimentar':
                    return 'Alimentar';
                case 'medicamentosa':
                    return 'Medicamentosa';
                case 'ansiedade':
                    return 'Ansiedade';
                case 'medo':
                    return 'Medo';
                case 'aguda':
                    return 'Aguda';
                case 'cronica':
                    return 'Crônica';
                case 'executed':
                    return 'Executado';
                case 'observed':
                    return 'Observado';
                case 'observations':
                    return 'Observações';
                case 'central':
                    return 'Central';
                case 'periferico':
                    return 'Periférico';
                case 'centralPeriferico':
                    return 'Central ou Periférico';
                case 'bombaInstalada':
                    return 'Instalada Bomba';
                case 'retorno':
                    return 'Retorno';
                case 'safe-travel':
                    return 'Deslocamento Seguro';
                case 'unsafe-travel':
                    return 'Deslocamento Inseguro';
                case 'ambulance':
                    return 'Ambulância';
                case 'bicycle':
                    return 'Bicicleta';
                case 'driven-car':
                    return 'Carro - Conduzindo';
                case 'passenger-car':
                    return 'Carro - Passageiro';
                case 'walking':
                    return 'Caminhando';
                case 'public-transport':
                    return 'Transporte público';
                case 'first-time':
                    return 'Primeira Vez';
                case 'followup':
                    return 'Acompanhamento';
                case 'protocol-change':
                    return 'Mudança de Protocolo';
                case 'medical-request':
                    return 'Solicitação Médica';
                case 'patient-request':
                    return 'Solicitação Paciente';
                case 'social':
                    return 'Social';
                case 'elevated':
                    return 'Elevado';
                case 'currentWeight':
                    return 'Peso Atual';
                case 'weight1MonthAgo':
                    return 'Peso há 1 mês atrás';
                case 'weight6MonthsAgo':
                    return 'Peso há 6 meses atrás';
                case 'weightLoss':
                    return 'Perda de Peso';
                case 'weightVariation2Weeks':
                    return 'Variação de Peso nas últimas 2 semanas';
                case 'functionalActivity':
                    return '';
                case 'metabolicStress':
                    return '';
                case 'lastWeek':
                    return 'Na última semana';
                case 'lastMonth':
                    return 'No último mês';
                case 'last3Months':
                    return 'Nos últimos 3 meses';
                case 'last6Months':
                    return 'Nos últimos 3 meses';
                case 'changed':
                    return 'Alterada';
                case 'take-care-of-children':
                    return 'Cuidar das crianças';
                case 'care-at-home':
                    return 'Cuidados em casa';
                case 'health-plan-and-finances':
                    return 'Plano de saúde e finanças';
                case 'transport':
                    return 'Transporte';
                case 'work-and-school':
                    return 'Trabalho e escola';
                case 'children':
                    return 'Filhos';
                case 'partner':
                    return 'Companheiro(a)';
                case 'loss-of-faith':
                    return 'Perda da fé';
                case 'related-to-god':
                    return 'Relacionamento com Deus';
                case 'loss-of-the-meaning-and-purpose-of-life':
                    return 'Perda do sentido e propósito da vida';
                case 'depression':
                    return 'Depressão';
                case 'fears':
                    return 'Medos';
                case 'nervousness':
                    return 'Nervosismo';
                case 'sadness':
                    return 'Tristeza';
                case 'concern':
                    return 'Preocupação';
                case 'loss-of-interest-in-usual-activities':
                    return 'Perda de interesse nas atividades habituais';
                case 'amount-of-information':
                    return 'Quantidade de informações';
                case 'quality-clarity-of-info':
                    return 'Qualidade e clareza das informações';
                case 'communication-with-the-team':
                    return 'Comunicação com a equipe';
                case 'food':
                    return 'Alimentação';
                case 'appearance':
                    return 'Aparência';
                case 'constipation':
                    return 'Constipação';
                case 'take-a-walk':
                    return 'Caminhar';
                case 'diarrhea':
                    return 'Diarreia';
                case 'pains':
                    return 'Dores';
                case 'to-sleep':
                    return 'Dormir';
                case 'fatigue':
                    return 'Fadiga';
                case 'fever':
                    return 'Febre';
                case 'metallic-taste-in-the-mouth':
                    return 'Gosto metálico na boca';
                case 'indigestion':
                    return 'Indigestão';
                case 'tinging-hands-feet':
                    return 'Formigamento nas mãos e pés';
                case 'memory-and-or-concentration':
                    return 'Memória e/ou concentração';
                case 'mucositis-and-or-afta':
                    return 'Mucosite e/ou afta';
                case 'changes-in-urination':
                    return 'Alterações na urina';
                case 'dry-and-or-congested-nose':
                    return 'Nariz seco e/ou congestionado';
                case 'nausea-and-or-vomiting':
                    return 'Náusea e/ou vômito';
                case 'dry-and-or-itchy-skin':
                    return 'Pele seca e/ou com coceira';
                case 'breathing':
                    return 'Respiração';
                case 'feeling-bloated':
                    return 'Sensação de inchaço';
                case 'sexual':
                    return 'Vida sexual';
                case 'shower-and-dress':
                    return 'Banho e vestir-se';
                case 'patientInvestigating':
                    return 'em Investigação Diagnóstica';
                case 'oncologicPatient':
                    return 'Oncológico';
                case 'notPatientOncologic':
                    return 'não Oncológico';
                case 'inPersonAppointment':
                    return 'Consulta Presencial';
                case 'remoteAppointment':
                    return 'Consulta Remota';
                case 'stagingPatient':
                    return 'em Estadiamento';
                case 'treatmentPatient':
                    return 'em Tratamento';
                case 'followUpPatient':
                    return 'em Seguimento';
                case 'palliativeCarePatient':
                    return 'em Cuidados Paliativos';
                case 'dischargePatient':
                    return 'em Alta Médica';
                case 'prevention':
                    return 'Escolheu Preservação';
                case 'not-prevention':
                    return 'Recusou Preservação';
                case 'ovum':
                    return 'Óvulos';
                case 'semen':
                    return 'Sêmen';
                case 'peripheral':
                    return 'Periférico';
                case 'central':
                    return 'Central';
                case 'liver':
                    return 'Fígado';
                case 'bones':
                    return 'Ossos';
                case 'lung':
                    return 'Pulmão';
                case 'soft_tissues':
                    return 'Tecidos Moles';
                case 'lymph_nodes':
                    return 'Linfonodos';
                case 'skin':
                    return 'Pele';
                case 'SNC':
                    return 'SNC';
                case 'present':
                    return 'Presente';
                case 'absent':
                    return 'Ausente';
                case 'accomplished':
                    return 'Realizada';
                case 'not-accomplished':
                    return 'Não Realizada';
                case 'positive':
                    return 'Positivo';
                case 'negative':
                    return 'Negativo';
                case '':
                    return '';
                default:
                    return answer;
            }
        } else {
            return answer;
        }
    }
}
